<div class="w-full h-screen flex flex-col items-center justify-center gap-5">
    <span class="text-9xl text-blue-600 font-bold" data-aos="fade-right" data-aos-delay="100">404</span>
    <span class="text-xl text-zinc-400" data-aos="fade-right" data-aos-delay="200">Page not found</span>
    <div class="flex gap-5" data-aos="fade-right" data-aos-delay="300">
        <a [routerLink]="'/'" class="px-6 py-3 bg-blue-600 rounded text-sm font-semibold uppercase hover:bg-blue-500 duration-300">
            Go back
        </a>
    </div>
</div>